"use strict";
/**
 * The required format for a boolean flag key.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsKeysEnum = void 0;
exports.testFlagEnumValidity = testFlagEnumValidity;
/**
 * Helper function to test that enum keys and values match correct format.
 *
 * It is not possible as of Typescript 5.2 to declare a type for an enum key or value in-line.
 * Therefore, we must test the enum via a helper function that abstracts the enum to an object.
 *
 * If the test fails, you should review your `enum` to verify that both the
 * keys and values match the format specified by the `FlagKey` template literal type.
 * ref: https://stackoverflow.com/a/58181315
 *
 * @param testEnum - the Enum to type check
 */
function testFlagEnumValidity(_) { }
var FeatureFlagsKeysEnum;
(function (FeatureFlagsKeysEnum) {
    // Boolean flags
    FeatureFlagsKeysEnum["IS_API_IDEMPOTENCY_ENABLED"] = "IS_API_IDEMPOTENCY_ENABLED";
    FeatureFlagsKeysEnum["IS_API_RATE_LIMITING_DRY_RUN_ENABLED"] = "IS_API_RATE_LIMITING_DRY_RUN_ENABLED";
    FeatureFlagsKeysEnum["IS_API_RATE_LIMITING_ENABLED"] = "IS_API_RATE_LIMITING_ENABLED";
    FeatureFlagsKeysEnum["IS_CONTROLS_AUTOCOMPLETE_ENABLED"] = "IS_CONTROLS_AUTOCOMPLETE_ENABLED";
    FeatureFlagsKeysEnum["IS_EMAIL_INLINE_CSS_DISABLED"] = "IS_EMAIL_INLINE_CSS_DISABLED";
    FeatureFlagsKeysEnum["IS_EVENT_QUOTA_LIMITING_ENABLED"] = "IS_EVENT_QUOTA_LIMITING_ENABLED";
    FeatureFlagsKeysEnum["IS_HUBSPOT_ONBOARDING_ENABLED"] = "IS_HUBSPOT_ONBOARDING_ENABLED";
    FeatureFlagsKeysEnum["IS_INTEGRATION_INVALIDATION_DISABLED"] = "IS_INTEGRATION_INVALIDATION_DISABLED";
    FeatureFlagsKeysEnum["IS_NEW_MESSAGES_API_RESPONSE_ENABLED"] = "IS_NEW_MESSAGES_API_RESPONSE_ENABLED";
    FeatureFlagsKeysEnum["IS_PLAYGROUND_ONBOARDING_ENABLED"] = "IS_PLAYGROUND_ONBOARDING_ENABLED";
    FeatureFlagsKeysEnum["IS_QUOTA_LIMITING_ENABLED"] = "IS_QUOTA_LIMITING_ENABLED";
    FeatureFlagsKeysEnum["IS_TEMPLATE_STORE_ENABLED"] = "IS_TEMPLATE_STORE_ENABLED";
    FeatureFlagsKeysEnum["IS_USAGE_ALERTS_ENABLED"] = "IS_USAGE_ALERTS_ENABLED";
    FeatureFlagsKeysEnum["IS_USE_MERGED_DIGEST_ID_ENABLED"] = "IS_USE_MERGED_DIGEST_ID_ENABLED";
    FeatureFlagsKeysEnum["IS_V2_ENABLED"] = "IS_V2_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_NODE_PREVIEW_ENABLED"] = "IS_WORKFLOW_NODE_PREVIEW_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_CHECK_LIST_ENABLED"] = "IS_WORKFLOW_CHECK_LIST_ENABLED";
    FeatureFlagsKeysEnum["IS_TIER_DURATION_RESTRICTION_EXCLUDED_ENABLED"] = "IS_TIER_DURATION_RESTRICTION_EXCLUDED_ENABLED";
    FeatureFlagsKeysEnum["IS_2025_Q1_TIERING_ENABLED"] = "IS_2025_Q1_TIERING_ENABLED";
    FeatureFlagsKeysEnum["IS_LEGACY_TO_2025_Q1_TIER_MIGRATION_ENABLED"] = "IS_LEGACY_TO_2025_Q1_TIER_MIGRATION_ENABLED";
    FeatureFlagsKeysEnum["IS_WORKFLOW_LIMIT_ENABLED"] = "IS_WORKFLOW_LIMIT_ENABLED";
    FeatureFlagsKeysEnum["IS_MAX_WORKFLOW_LIMIT_ENABLED"] = "IS_MAX_WORKFLOW_LIMIT_ENABLED";
    FeatureFlagsKeysEnum["IS_MAX_STEPS_PER_WORKFLOW_ENABLED"] = "IS_MAX_STEPS_PER_WORKFLOW_ENABLED";
    // Numeric flags
    FeatureFlagsKeysEnum["MAX_WORKFLOW_LIMIT_NUMBER"] = "MAX_WORKFLOW_LIMIT_NUMBER";
})(FeatureFlagsKeysEnum || (exports.FeatureFlagsKeysEnum = FeatureFlagsKeysEnum = {}));
//# sourceMappingURL=feature-flags.js.map